import { createUseStyles } from 'react-jss';

const styles = {
  backdrop: {
    height: '100%',
    top: '0',
    left: '0',
    width: '100%',
    background: 'rgba(250, 250, 250, 0.72)',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute'
  }
};

export const useStyles = createUseStyles(styles, {
  name: 'Loading'
});
